import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter, Observable } from 'rxjs';
import { ConfigurationService } from '../../services/configuration.service';
import { DriftConfiguration } from 'src/app/models/configuration.interface';
import {
  CollectionLinkUnlinkRequest,
  UploadFilesRequest,
  UploadLinksResponse,
  DeleteFilesRequest,
  WorkspaceDocumentsResponse
} from '../models/documents';

@Injectable()
export class WorkspaceDocsCollectionsService {
  private readonly workspaceUrl = '/workspace';
  private config!: DriftConfiguration;
  constructor(
    private readonly httpClient: HttpClient,
    private readonly configurationService: ConfigurationService
  ) {
    //No unsub required
    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }
  private get apiUrl() {
    return `${this.config.driftApi}${this.workspaceUrl}`;
  }

  /**
   * Attaches existing collections to a workspace, copying all documents.
   */
  public linkCollections(workspaceId: string, data: CollectionLinkUnlinkRequest): Observable<void> {
    const path = `${this.apiUrl}/${workspaceId}/collections/link`;
    return this.httpClient.post<void>(path, data);
  }

  /**
   * Detaches linked collections from a workspace, deleting associated documents.
   */
  public unlinkCollections(workspaceId: string, data: CollectionLinkUnlinkRequest): Observable<void> {
    const path = `${this.apiUrl}/${workspaceId}/collections/unlink`;
    return this.httpClient.post<void>(path, data);
  }

  /**
   * Generates pre-signed S3 URLs for uploading files to a workspace.
   */
  public getUploadUrls(workspaceId: string, data: UploadFilesRequest): Observable<UploadLinksResponse> {
    const path = `${this.apiUrl}/${workspaceId}/documents/upload`;
    return this.httpClient.post<UploadLinksResponse>(path, data);
  }

  public deleteWorkspaceFiles(workspaceId: string, data: DeleteFilesRequest): Observable<void> {
    const path = `${this.apiUrl}/${workspaceId}/documents/delete`;
    return this.httpClient.post<void>(path, data);
  }

  public getWorkspaceDocuments(workspaceId: string): Observable<WorkspaceDocumentsResponse> {
    const path = `${this.apiUrl}/${workspaceId}/documents`;
    return this.httpClient.get<WorkspaceDocumentsResponse>(path);
  }
}
